"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const throwValidationError_1 = __importDefault(require("./throwValidationError"));
const EMPTY_FUNCTION = () => {
    throw new Error('This function should never be called, it is mean only to guide the type system');
};
const buildValidator = (typeName, simpleValidator) => {
    const validator = (value, options) => {
        const isValid = simpleValidator(value, options);
        if (!isValid && options) {
            (0, throwValidationError_1.default)(options.path, typeName, `${value}`);
        }
        return isValid;
    };
    validator.v = EMPTY_FUNCTION;
    validator.typeName = typeName;
    return validator;
};
exports.default = buildValidator;
